import React, { useEffect, useState } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import "./profilepicture.css";
import Button from "../../../../../../components/button";
import { toast } from "react-toastify";
//services
import { getVerifyToken, updateProfilePicture, updateVerifyToken } from "../../../../../../services/medium";
// import { requestScreenNameChange } from "../../../../../../services/profile";
import { Link, useParams } from "react-router-dom";
import { copyToClipboard } from "../../../../../../utils/helpers";
//import moment from "moment";
//import { da } from "date-fns/locale";

const defaultSrc = 'https://lh3.googleusercontent.com/i7cTyGnCwLIJhT1t2YpLW-zHt8ZKalgQiqfrYnZQl975-ygD_0mOXaYZMzekfKW_ydHRutDbNzeqpWoLkFR4Yx2Z2bgNj2XskKJrfw8'

export default function ProfilePicture({ info, getProfile }) {
  const params = useParams();
  const profile_image = info.profile_image;
  const encoded_image = info.encoded_image;
  const encrypted_id = info.encrypted_id;
  // const personal_booking_link = info.personal_booking_link;
  //const { profile_image ,encoded_image } = useSelector((state) => state.user.user);
  const [image, setImage] = useState(defaultSrc);
  const [cropData, setCropData] = useState("#");
  const [cropper, setCropper] = useState();
  const [popup, setPopup] = useState(false);
  //const [message, setMessage] = useState("");
  //const [selectedFile, setselectedFile] = useState(null);
  const [copy, setCopy] = useState(false);
  const [copy1, setCopy1] = useState(false);
  const [copy2, setCopy2] = useState(false);
  const [copy3, setCopy3] = useState(false);
  const [verifiedImage, setImageVerified] = useState(0);

  const copyText = (e, value) => {
    let location = window.location.origin;
    let url = `${location}/embeded/${encrypted_id}`
    setCopy(true);
    e.stopPropagation();
    copyToClipboard(`<iframe width="100%" height="320"  src="${url}"  />`);
    setTimeout(() => {
      setCopy(false);
    }, 3000);
  };
  const copyText1 = (e, value) => {
    let location = window.location.origin;
    let url = `${location}/embeded-code/${encrypted_id}`
    setCopy1(true);
    e.stopPropagation();
    copyToClipboard(url);
    setTimeout(() => {
      setCopy1(false);
    }, 3000);
  };
  const copyVerifiedBatch = (e, value) => {
    let location = window.location.origin;
    let url = `${location}/verysoul-verified/${params.id}`;
    setCopy2(true);
    e.stopPropagation();
    let body = {
      id: params.id,
      token_status: 1

    }
    updateVerifyToken(body).then(() => {
      setImageVerified(1)
    }).catch(() => { })
    copyToClipboard(`<iframe width="224" height="218"  src="${url}"  />`);
    setTimeout(() => {
      setCopy2(false);
    }, 3000);
  }

  const removeVerifiedBatch = (e) => {

    e.stopPropagation();


    let body = {
      id: params.id,
      token_status: 0

    }
    updateVerifyToken(body).then(() => {
      setImageVerified(0)
      setCopy3(true);
      setTimeout(() => {
        setCopy3(false);
      }, 3000)
    }).catch(() => { });
  }
  useEffect(() => {
    console.log('ejdj', info)
    setImage(encoded_image)
  }, [profile_image])


  const closePopup = () => setPopup(false);
  const openPopup = () => {
    setPopup(true)
  };

  const MAX_SIZE_MB = 2;
  const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
  const sizeErrorMessage = (bytes) =>
    `Your image is ${(bytes / (1024 * 1024)).toFixed(2)} MB. Profile picture must be ${MAX_SIZE_MB} MB or less. Please resize or compress it, or send it to support@verysoul.com.`;

  const onChange = (e) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const file = files && files[0];
    if (e.target) e.target.value = ""; // allow re-selecting the same file
    if (!file) return;

    // if (!file.type.startsWith("image/")) {
    //   toast.error("Please choose an image file (JPG, PNG, GIF or WEBP).", { position: "top-center" });
    //   return;
    // }
    if (file.size > MAX_SIZE_BYTES) {
      toast.error(sizeErrorMessage(file.size), { position: "top-center" });
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(file);
  };
const getCropData = () => {
  if (!cropper) return;

  const canvas = cropper.getCroppedCanvas({
      // Profile photos are shown at ~130px; 400px keeps them sharp on
      // retina screens while keeping the file around 30-60 KB.
      maxWidth: 400,
      maxHeight: 400,
      fillColor: "#fff",
      imageSmoothingEnabled: true,
      imageSmoothingQuality: "high",
    });
  if (!canvas) return;

  // Re-encode the crop, lowering JPEG quality until it fits within the limit
  const qualities = [0.92, 0.85, 0.75, 0.65, 0.5];
  const tryEncode = (i) => {
    canvas.toBlob((blob) => {
      if (!blob) return;
      if (blob.size > MAX_SIZE_BYTES) {
        if (i + 1 < qualities.length) return tryEncode(i + 1);
        toast.error(sizeErrorMessage(blob.size), { position: "top-center" });
        return;
      }
      const file = new File([blob], "profile.jpg", { type: "image/jpeg" });
      updalodaImage(file);
    }, "image/jpeg", qualities[i]);
  };
  tryEncode(0);
};

  const updalodaImage = (file) => {
  const formData = new FormData();

  formData.append("image", file, file.name);
  formData.append("medium_id", params.id);

  updateProfilePicture(formData)
    .then((data) => {
      toast.success("Updated successfully", { position: "top-center" });
      setPopup(false);
      getProfile(params.id);
    })
    .catch(() => {});
};
  useEffect(() => {
    getVerifyToken(params.id).then((data) => {
      if (data.data.data) {
        setImageVerified(data.data.data.is_verify_token)
      }

    }).catch(() => { })
  }, [])

  return (
    <div className="row-one-step">

      <>
        {parseInt(info.mediumship_level) === 3 || parseInt(info.mediumship_level) === 6 || parseInt(info.mediumship_level) === 7 ? <>

          <div className="d-flex align-items-center justify-content-end pointer">
            <Link
              className="public-profile-btn"
              to={`/public-view/${params.id}`}
              target="_blank"
            >
              View Public Profile
            </Link>
          </div>
          <div className="d-flex align-items-center justify-content-end pointer mt-2">
            <div>

              <Button
                status={0}
                type="button"
                className={`resend-btn w-unset height-45 min-width-130px`}
                onClick={copyText}
                title={copy ? "Copied" : "Copy Embedded"}
              />

            </div>
          </div>
         

        </>
          : ''}
           <div className="d-flex align-items-center justify-content-end pointer mt-2">
            <div>

              <Button
                status={0}
                type="button"
                className={`resend-btn w-unset height-45 min-width-130px`}
                onClick={copyText1}
                title={copy1 ? "Copied" : "Copy Guest Link"}
              />

            </div>
          </div>
        <div className="d-flex align-items-center justify-content-end pointer mt-2">
          <div className="d-flex items-center mr-4 mt-2">
            <span className="color-d5a67b pointer "> Is Verified Image Added :&nbsp;</span> <span>{(verifiedImage == 2|| verifiedImage == 1) ? 'Yes' : 'No'}</span>
          </div>
          {console.log(verifiedImage)}
          {(verifiedImage == 2 || verifiedImage == 1) && <Button
            status={0}
            type="button"
            className={`resend-btn w-unset height-45 min-width-130px`}
            onClick={removeVerifiedBatch}
            title={copy3 ? "Removed" : "Remove Verified Badge"}
          />}
          {verifiedImage === 0 && <div>

            <Button
              status={0}
              type="button"
              className={`resend-btn w-unset height-45 min-width-130px ml-2`}
              onClick={copyVerifiedBatch}
              title={copy2 ? "Enabled" : "Enable Verified Badge"}
            />

          </div>}

        </div>
        <div className="d-flex align-items-center">
          <img
            className="main-profile-image"
            id="main-profile-image"
            src={
              profile_image !== null
                ? `${process.env.REACT_APP_IMAGE_URL}${profile_image}`
                : "/images/user-dummy.png"
            }
          />
          <div className="ml-2">
            {/* <span class="cropper-btn-file resend-btn w-unset height-45 min-width-130px">
                            {profile_image === null ? "Upload" : "Request Change"}<input type="file" onChange={onChange} />
                        </span> */}
            <Button
              status={0}
              type="button"
              className={`resend-btn w-unset height-45 min-width-130px`}
              onClick={openPopup}
              // title={requestChangePhoneNo ? "Submit" : "Request Change"}
              title={"Upload"}
            />
            {/* {toast.success(message, { position: "top-center" })} */}
            {/* <span className="green font-size-11 d-block mt-1"> {message}</span> */}
          </div>

          {popup && (
            <div className="cropper-wrapper">
              <div className="cropper-container-inner">
                <span class="cropper-btn-file resend-btn w-unset height-45 min-width-130px">
                  Choose Image...
                  <input type="file" onChange={onChange} />
                </span>
                 <p className="image-note">
  <strong>Note:</strong> Your profile picture needs to be 2 MB or less. 
  If your file is<br/> larger, you can reduce its size by resizing or compressing it, 
  or <br/> send it to support@verysoul.com.
</p>

                <Cropper
                  style={{ height: 400, width: 500, backgroundColor: "gray", opacity: 1 }}
                  zoomTo={0.1}
                  initialAspectRatio={1}
                  preview=".img-preview"
                  src={image}
                  dragMode="move"
                  viewMode={1}
                  minCropBoxHeight={10}
                  minCropBoxWidth={10}
                  background={true}
                  responsive={true}
                  rounded={true}
                  autoCropArea={1}
                  checkOrientation={false}
                  onInitialized={(instance) => {
                    setCropper(instance);
                  }}
                  guides={true}
                />
                <Button
                  status={0}
                  type="button"
                  className={`resend-btn w-unset height-45 min-width-130px mt-1 pointer`}
                  onClick={getCropData}
                  // title={requestChangePhoneNo ? "Submit" : "Request Change"}
                  title={"Upload"}
                />
                <Button
                  status={0}
                  type="button"
                  className={`resend-btn w-unset height-45 min-width-130px ml-2 mt-1 pointer`}
                  onClick={closePopup}
                  // title={requestChangePhoneNo ? "Submit" : "Request Change"}
                  title={"Cancel"}
                />
              </div>
            </div>
          )}
        </div>
        {/* <div className="pfil-name">
                    <img style={{ width: "100%" }} src={cropData} alt="cropped" />
                </div> */}
      </>
    </div>
  );
}
